<template>
    <div v-if="editRecommended.length" class="machine-config">
        <BasicTitle title="设备配置"></BasicTitle>
        <!--   配置导航   -->
        <div class="config-nav-wrap">
            <div @click="handleSwitchActive(item.key)" :class="{'nav-item-active': selectRecommend.key === item.key}" class="nav-item" v-for="item in editRecommended">{{ item.navTitle }}</div>
        </div>

        <!--   当前激活的配置视图   -->
        <MachineConfigView :selectRecommend="selectRecommend" readonly></MachineConfigView>
    </div>
</template>

<script>
import BasicTitle from './basictitle';
import MachineConfigView from './machineconfigview';
import {mapState} from "vuex";


export default {
    name: "machineConfig",
    components: {
        BasicTitle,
        MachineConfigView
    },
    computed: {
        ...mapState({
            // 配置数据
            arrRecommended: state => state.hvacMappingEntry.arrRecommended,
        }),
        // 配置完成的数据
        editRecommended() {
            return this.arrRecommended.filter(i => i.edit);
        },
        // 选中的配置数据
        selectRecommend() {
            const select = this.editRecommended.find(i => i.select);
            if (!select) this.editRecommended[0].select = true;
            return select ?? this.arrRecommended[0];
        }
    },
    methods: {
        /**
         * 切换激活的配置
         * @param key
         */
        handleSwitchActive(key) {
            const list = this.arrRecommended.map(i => {
                i.select = i.key === key;
                return i;
            });
            this.$store.commit({type: 'hvacMappingEntry/CHANGE_RECOMMENDED_LIST', list});
        }
    }
}
</script>

<style scoped lang="scss">
.machine-config {
    padding: 32px 24px 24px;
    background: #FFFFFF;
    border-radius: $commonRadius;
    margin-bottom: 28px;

    .config-nav-wrap {
        display: flex;
        align-items: center;
        padding-top: 28px;
        margin-bottom: 30px;
        border-bottom: 1px solid #F6F6F6;

        .nav-item {
            line-height: 36px;
            padding-bottom: 12px;
            height: 48px;
            color: #858585;
            margin-right: 64px;

            &:last-of-type {
                margin-right: 0;
            }
        }

        .nav-item-active {
            background: $userBgGradient no-repeat bottom center / 100% 4px;
            font-weight: 500;
            color: $deepGreen;
        }
    }
}
</style>